import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';
import { Area } from '@ilteducation/content-ref-data-types';
import { VideoV1 } from '@ilteducation/content-registry-types';
import store from '@/store';
import eventBus from '@/foundations/services/eventBus';
import { useOrderedVideos } from '@/comp/use-ordered-videos';
import { getTitle } from '@/foundations/helpers/videoUtils';


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoList',
  props: {
    area: null,
    videos: null
  },
  setup(__props: any) {

const props = __props as { area: Area; videos?: VideoV1[] }



const areaVideos = ref<VideoV1[]>([]);
watch(
  () => props.videos,
  (newVideos) => {
    if (props.videos === undefined) {
      useOrderedVideos()
        .fetchVideos(props.area.id)
        .then((videos) => {
          areaVideos.value = videos;
        });
    }
    areaVideos.value = newVideos;
  },
);

const canSaveOrder = ref(false);
const loading = ref(false);
const updateVideoOrder = async () => {
  loading.value = true;
  try {
    const listedVideos = areaVideos.value;
    // The list is read from content-search, which can lag behind content-registry. Base the update on
    // the current orderedAreas from content-registry, otherwise a video can be skipped as "already in place"
    // or have outdated orders for other areas written back.
    const currentVideos: VideoV1[] = await Promise.all(
      listedVideos.map((video) => store.dispatch('videos/getOne', { id: video.id }).then((res) => res.data)),
    );
    const results = await Promise.allSettled(
      currentVideos.map((video, index) => {
        if (video.orderedAreas.find((areaOrder) => areaOrder.id === props.area.id)?.order === index) {
          listedVideos[index].orderedAreas = video.orderedAreas;
          return Promise.resolve();
        }
        const newOrder = [
          ...video.orderedAreas.filter((areaOrder) => areaOrder.id !== props.area.id),
          { id: props.area.id, order: index },
        ];
        return store
          .dispatch('videos/update', {
            id: video.id,
            data: [
              {
                op: 'replace',
                path: '/orderedAreas',
                value: newOrder,
              },
            ],
          })
          .then(() => {
            // only update the local copy once saved, so a failed video is retried on the next save
            listedVideos[index].orderedAreas = newOrder;
          });
      }),
    );
    const failedCount = results.filter((result) => result.status === 'rejected').length;
    if (failedCount > 0) {
      eventBus.$emit('snackbarV2.open', {
        text: `Could not update the order of ${failedCount} of ${results.length} videos. Try saving again.`,
        color: 'error',
      });
    } else {
      canSaveOrder.value = false;
    }
  } catch (error) {
    eventBus.$emit('snackbarV2.open', { text: `Could not save order: ${(error as Error).message}`, color: 'error' });
  } finally {
    loading.value = false;
  }
};

return { __sfc: true,props, areaVideos, canSaveOrder, loading, updateVideoOrder, getTitle }
}

})